// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-10f9b484]:export{primaryColor:#052e83;secondaryColor:#00a4a0;accentColor:#e30513}", ""]);
// Exports
module.exports = exports;
